export const OTEL_ENABLED = window.CONFIG?.OTEL_ENABLED === 'true'
export const OTEL_ENDPOINT = window.CONFIG?.OTEL_ENDPOINT ?? ''
